import * as React from "react";

import { ComponentType } from "react";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import ReactTable, { RowInfo } from "react-table";
import { bindActionCreators } from "redux";
import { InlineLoading } from "src/components/common";
import * as NavigationActions from "../../../actions/navigation";
import * as TrialActions from "../../../actions/trial";
import * as TrialInstitutionItemCustomViewActions from "../../../actions/trialInstitutionItemCustomView";
import { FormFilterInput } from "../../../components/form";
import { Link } from "../../../components/routing/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import {
    DEFAULT_PAGE_SIZE,
    PAGE_SIZE_OPTIONS,
} from "../../../constants/reactTableConstants";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { TrialInstitutionItemCustomViewBreadcrumbs } from "../../../helpers/breadcrumbHelper";
import { TrialSubMenu } from "../../../helpers/subMenuHelper";
import RouterHoc, {
    IRouterActions,
    IRouterProps,
} from "../../../hoc/RouterHoc";
import { IFormFilter, ITmdState } from "../../../reducers/index";
import { TrialLayout } from "../../index";

import "./TrialInstitutionItemCustomViewsPage.scss";

interface ITrialInstitutionItemCustomViewsPageParams {
    trialId: number;
}

interface ITrialInstitutionItemCustomViewsPageProps
    extends IRouterProps<ITrialInstitutionItemCustomViewsPageParams> {
    trialId: number;

    // From state
    formFilter: IFormFilter;
    trial: Dtos.Trial;
    trialInstitutionItemCustomViews: Dtos.TrialInstitutionItemCustomView[];

    loadingTrial: boolean;
    loadTrialSuccess: boolean;
    loadTrialFailure: boolean;
    loadTrialErrorCode: string;

    loadingTrialInstitutionItemCustomViews: boolean;
    loadTrialInstitutionItemCustomViewSuccess: boolean;
    loadTrialInstitutionItemCustomViewFailure: boolean;
    loadTrialInstitutionItemCustomViewErrorCode: string;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface ITrialInstitutionItemCustomViewsPageActions extends IRouterActions {
    clearTrial: TrialActions.ITrialClearActionCreator;
    loadTrial: TrialActions.ITrialLoadByIdActionCreator;
    loadTrialInstitutionItemCustomViews: TrialInstitutionItemCustomViewActions.ITrialInstitutionItemCustomViewLoadActionCreator;
    filter: TrialInstitutionItemCustomViewActions.ITrialInstitutionItemCustomViewFilterActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type TrialInstitutionItemCustomViewsPageProps =
    ITrialInstitutionItemCustomViewsPageProps &
        ITrialInstitutionItemCustomViewsPageActions;

class TrialInstitutionItemCustomViewsPage extends React.PureComponent<
    TrialInstitutionItemCustomViewsPageProps,
    any
> {
    initialised: boolean;
    constructor(props: TrialInstitutionItemCustomViewsPageProps) {
        super(props);
    }

    componentDidMount() {
        const {
            loadTrial,
            loadTrialInstitutionItemCustomViews,
            trialId,
            setDrawerItems,
            setBreadcrumbs,
            permissions
        } = this.props;
        

        setDrawerItems(TrialSubMenu(trialId, permissions));
        setBreadcrumbs(TrialInstitutionItemCustomViewBreadcrumbs(trialId));

        loadTrial(trialId);
        loadTrialInstitutionItemCustomViews(trialId);
    }

    componentWillReceiveProps(
        nextProps: TrialInstitutionItemCustomViewsPageProps
    ) {}

    componentDidUpdate(
        prevProps: TrialInstitutionItemCustomViewsPageProps,
        prevState
    ) {
        const {
            trialId,
            trial,
            setBreadcrumbs,
            permissions,
            setDrawerItems,
            loadTrialFailure,
            loadTrialInstitutionItemCustomViewFailure,
            navigate,
            loadTrialInstitutionItemCustomViewErrorCode,
            loadTrialErrorCode,
        } = this.props;

        if (loadTrialFailure) {
            navigate(`/error/${loadTrialErrorCode}`);
        }
        if (loadTrialInstitutionItemCustomViewFailure) {
            navigate(`/error/${loadTrialInstitutionItemCustomViewErrorCode}`);
        }

        if (trial?.displayName && !this.initialised) {
            setBreadcrumbs(
                TrialInstitutionItemCustomViewBreadcrumbs(
                    trialId,
                    trial.displayName
                )
            );
            setDrawerItems(TrialSubMenu(trialId, permissions));
            this.initialised = true;
        }
    }

    componentWillUpdate(nextProps: TrialInstitutionItemCustomViewsPageProps) {}

    componentWillUnmount() {
        this.clear();
    }

    clear() {
        this.props.clearTrial();
    }

    showInstitutionItems(): boolean {
        const {
            loadingTrial,
            loadingTrialInstitutionItemCustomViews,
            loadTrialSuccess,
        } = this.props;

        if (
            !loadingTrial &&
            loadTrialSuccess &&
            !loadingTrialInstitutionItemCustomViews
        ) {
            return true;
        }

        return false;
    }

    render() {
        const { loadingTrial, loadingTrialInstitutionItemCustomViews } =
            this.props;

        return (
            <TrialLayout
                loading={loadingTrial || loadingTrialInstitutionItemCustomViews}
                permission={Dtos.Permission.TrialItemUpdate}
            >
                {this.renderContent()}
            </TrialLayout>
        );
    }

    renderContent() {
        const { trial, trialId, permissions } = this.props;

        return (
            <div>
                <div className="row">
                    <div className={"col-auto mb-2"}>
                        <h1>Institution Item Views</h1>
                    </div>
                    <div
                        className="col d-flex justify-content-end align-items-stretch"
                        style={{ height: "38px" }}
                    >
                        <FormFilterInput
                            formFilter={this.props.formFilter}
                            onFilter={(e) => this.props.filter(e)}
                        />
                        {AuthenticationHelper.hasPermission(
                            permissions,
                            Dtos.Permission.TrialItemUpdate,
                            trialId,
                            null
                        ) &&
                            trial &&
                            trial.id > 0 && (
                                <Link
                                    className={"btn btn-primary ml-2"}
                                    url={
                                        "/trials/" +
                                        trial.id +
                                        "/trialinstitutionitemviews/create"
                                    }
                                >
                                    Add View
                                </Link>
                            )}
                    </div>
                </div>
                {!this.showInstitutionItems() ? (
                    <InlineLoading absoluteCenter={true} size={50} />
                ) : null}
                {this.showInstitutionItems() ? (
                    <div className="card">
                        <div className="patient-tables">
                            {this.createTable()}
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    createTable() {
        const { trialInstitutionItemCustomViews, permissions } = this.props;

        if (
            !trialInstitutionItemCustomViews ||
            trialInstitutionItemCustomViews.length == 0
        ) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no views</span>
                    </div>
                </div>
            );
        }

        const showPagination =
            trialInstitutionItemCustomViews.length > DEFAULT_PAGE_SIZE;

        return (
            <div className="table-wrapper">
                <ReactTable
                    data={trialInstitutionItemCustomViews}
                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                    defaultPageSize={
                        showPagination
                            ? DEFAULT_PAGE_SIZE
                            : trialInstitutionItemCustomViews.length
                    }
                    pageSize={
                        showPagination
                            ? undefined
                            : trialInstitutionItemCustomViews.length
                    }
                    showPagination={showPagination}
                    className="-striped -highlight -clickable"
                    noDataText="There are currently no views to select"
                    resizable={false}
                    getTdProps={(
                        state,
                        rowInfo: RowInfo,
                        _column,
                        _instance
                    ) => {
                        return {
                            onClick: (e, handleOriginal) => {
                                const url =
                                    "/trials/" +
                                    rowInfo.original.trialId +
                                    "/trialinstitutionitemviews/" +
                                    rowInfo.original.id +
                                    "/dataentry";
                                this.props.navigate(url);

                                if (handleOriginal) {
                                    handleOriginal();
                                }
                            },
                        };
                    }}
                    defaultSorted={[
                        {
                            id: "name",
                            desc: false,
                        },
                    ]}
                    columns={[
                        {
                            id: "id",
                            Header: " ",
                            accessor: "id",
                            maxWidth: 50,
                            Cell: (_props) => (
                                <FontAwesomeIcon
                                    size="lg"
                                    icon={FontAwesomeIcons.Light.PENFIELD}
                                    fixedWidth
                                />
                            ),
                        },
                        {
                            id: "name",
                            Header: "Name",
                            accessor: "name",
                        },
                        {
                            id: "description",
                            Header: "Description",
                            accessor: "description",
                        },
                        {
                            id: "create",
                            Header: "",
                            maxWidth: 60,
                            Cell: (row) => (
                                <button
                                    disabled={
                                        !AuthenticationHelper.hasPermission(
                                            permissions,
                                            Dtos.Permission.TrialItemUpdate,
                                            row.original.trialId
                                        )
                                    }
                                    onClick={(e) => {
                                        const url =
                                            "/trials/" +
                                            row.original.trialId +
                                            "/trialinstitutionitemviews/" +
                                            row.original.id;
                                        this.props.navigate(url);
                                        e.stopPropagation();
                                    }}
                                    type="button"
                                    className="btn btn-outline-secondary btn-sm"
                                >
                                    <FontAwesomeIcon
                                        icon={FontAwesomeIcons.Light.EDIT}
                                        fixedWidth
                                    />
                                </button>
                            ),
                        },
                    ]}
                />
            </div>
        );
    }
}

const filter = (
    items: Dtos.TrialInstitutionItemCustomView[],
    filter: IFormFilter
): Dtos.TrialInstitutionItemCustomView[] => {
    if (items && filter) {
        if (!filter.showInActive) {
            items = items.filter((f) => f.active && f.active);
        }
        if (filter.search.length > 0) {
            items = items.filter(
                (f) =>
                    f.name.toLowerCase().indexOf(filter.search.toLowerCase()) >
                    -1
            );
        }
        return items;
    }

    return [];
};

const mapStateToProps = (
    state: ITmdState,
    ownProps: TrialInstitutionItemCustomViewsPageProps
): ITrialInstitutionItemCustomViewsPageProps => {
    let trial: Dtos.Trial | undefined = !(
        state.trials.formData instanceof Array
    )
        ? state.trials.formData
        : undefined;
    let trialInstitutionItemCustomViews:
        | Dtos.TrialInstitutionItemCustomView[]
        | undefined =
        state.trialInstitutionItemCustomView.formData instanceof Array
            ? state.trialInstitutionItemCustomView.formData
            : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        match: ownProps.match,
        trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,

        history: ownProps.history,
        location: ownProps.location,

        formFilter: state.trialInstitutionItemCustomView.formFilter,
        trial: trial!,
        trialInstitutionItemCustomViews: filter(
            trialInstitutionItemCustomViews!,
            state.trialInstitutionItemCustomView.formFilter!
        ),

        loadingTrial:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Pending,
        loadTrialSuccess:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Success,
        loadTrialFailure:
            state.trials.loadState &&
            state.trials.loadState.status == RequestState.Failure,
        loadTrialErrorCode: state.trials.loadState.errorCode,

        loadingTrialInstitutionItemCustomViews:
            state.trialInstitutionItemCustomView.loadState &&
            state.trialInstitutionItemCustomView.loadState.status ==
                RequestState.Pending,
        loadTrialInstitutionItemCustomViewSuccess:
            state.trialInstitutionItemCustomView.loadState &&
            state.trialInstitutionItemCustomView.loadState.status ==
                RequestState.Success,
        loadTrialInstitutionItemCustomViewFailure:
            state.trialInstitutionItemCustomView.loadState &&
            state.trialInstitutionItemCustomView.loadState.status ==
                RequestState.Failure,
        loadTrialInstitutionItemCustomViewErrorCode:
            state.trialInstitutionItemCustomView.loadState.errorCode,

        user: state.user.data,
        permissions: permissions,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: TrialInstitutionItemCustomViewsPageProps
): ITrialInstitutionItemCustomViewsPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
        clearTrial: bindActionCreators(TrialActions.Clear, dispatch),
        loadTrialInstitutionItemCustomViews: bindActionCreators(
            TrialInstitutionItemCustomViewActions.LoadTrialInstitutionItemCustomView,
            dispatch
        ),
        filter: bindActionCreators(
            TrialInstitutionItemCustomViewActions.Filter,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<
    ITrialInstitutionItemCustomViewsPageParams,
    TrialInstitutionItemCustomViewsPageProps
>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(
        TrialInstitutionItemCustomViewsPage
    ) as unknown as ComponentType<TrialInstitutionItemCustomViewsPageProps>
) as ComponentType<any>;
